import { render, staticRenderFns } from "./SchoolyearAddEdit.vue?vue&type=template&id=948ea878"
import script from "./SchoolyearAddEdit.vue?vue&type=script&lang=js"
export * from "./SchoolyearAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports